<template>
    <zen-one :showuserinfo="false" title="Kemaskini" :crumbs="crumbs">
        <z-page :append-button="true" title="Semak Pemilik">
            <w-flex column :gap="3">
                <w-form @submit.prevent="semakPemilik">
                    <w-flex column :gap="3">
                        <w-input v-model="data.nama">Nama Pemilik</w-input>
                        <w-input v-model="data.alamat1">Baris Alamat 1</w-input>
                        <w-input v-model="data.alamat2">Baris Alamat 2</w-input>
                        <w-input v-model="data.alamat3">Baris Alamat 3</w-input>
                        <w-select v-model="data.poskod" :items="poskods"
                            >Poskod</w-select
                        >
                        <w-select v-model="data.negeri" :items="negeris"
                            >Negeri</w-select
                        >
                        <w-button class="align-self-end" type="submit">
                            Simpan
                        </w-button>
                    </w-flex>
                </w-form>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { ref, defineComponent } from "vue";

export default defineComponent({
    setup() {
        const poskods = ref([
            { value: "1", label: "Poskod 1" },
            { value: "2", label: "Poskod 2" },
            { value: "3", label: "Poskod 3" },
        ]);

        const negeris = ref([
            { value: "1", label: "Negeri 1" },
            { value: "2", label: "Negeri 2" },
            { value: "3", label: "Negeri 3" },
        ]);

        const data = ref({
            nama: "Ainul Mardhiah",
            alamat1: "alamat1",
            alamat2: "alamat2",
            alamat3: "alamat3",
            poskod: "1",
            negeri: "1",
        });

        const crumbs = ref([
            { label: "iHasil", route: "/" },
            { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
            { label: "Kemaskini", route: "/cukai-tanah/kemaskini" },
            { label: "Ainul Mardhiah", route: "/" },
        ]);

        return {
            data,
            poskods,
            negeris,
            crumbs,
        };
    },
});
</script>

<style></style>
